import React from 'react';

export type ItemSubtitleVisibility = { subtitleVisible: boolean };

export const ItemSubtitleVisibilityContext =
  React.createContext<ItemSubtitleVisibility>({ subtitleVisible: true });
